@if (loading() || !memberProfile()) {
  <div class="absolute inset-0 z-50 flex items-center justify-center bg-neutral-0/80">
    <shared-loader></shared-loader>
  </div>
} @else {
  <div class="flex h-full flex-col gap-1.5">
    <div class="flex justify-between">
      <div class="flex items-center gap-2">
        <div class="flex items-center gap-2">
          <h2>{{ memberProfile().fullName }}</h2>
          <p class="subheader-1">({{ "profile.values.gender." + memberProfile().gender.toLowerCase() | translate }}, {{ calculateAge(memberProfile().birthDate) }} р.)</p>
          @if (checkFreemium(memberProfile())) {
            <span class="rounded-full border border-success-500 bg-success-100 px-1.5 py-0.5 text-xs font-thin">
              {{ "FREE" }}
            </span>
          }
        </div>
        <shared-contract-item
          type="status"
          [contract]="lastContract()"
        ></shared-contract-item>
      </div>
      <div class="flex items-center gap-2">
        @if (config().showPackageCoverage && lastContract()) {
          <members-package-coverage-button [userId]="memberProfile().userId"></members-package-coverage-button>
        }
        @if (config().showHealthCheckScheduler) {
          <members-health-status-check-scheduler [userId]="memberProfile().userId"></members-health-status-check-scheduler>
        }
        @if (config().showComments) {
          <members-comments-card [memberId]="memberProfile().id"></members-comments-card>
        }
      </div>
    </div>

    <nav
      mat-tab-nav-bar
      [tabPanel]="profileTabPanel"
    >
      @for (tab of tabs(); track tab.link) {
        <a
          mat-tab-link
          [routerLink]="tab.link"
          routerLinkActive
          #rla="routerLinkActive"
          [active]="rla.isActive"
        >
          {{ tab.label | translate }}
          <!-- Ambient rather than a control: the tab says the state is worth knowing, nothing more. -->
          @if (tab.dotClass; as dotClass) {
            <span
              class="ml-1.5 size-2 shrink-0 rounded-full"
              role="status"
              [class]="dotClass"
              [matTooltip]="tab.hintKey | translate"
              [attr.aria-label]="tab.hintKey | translate"
            ></span>
          }
        </a>
      }
    </nav>
    <mat-tab-nav-panel
      #profileTabPanel
      class="h-full w-full"
    >
      <router-outlet></router-outlet>
    </mat-tab-nav-panel>
  </div>
}
